/*
 * Module for showing generated intent example list from a custom utterance
 */

define([
  "marionette",
  "jquery",
  "configuration/properties",
  "modules/topicsSplit/topic/topicExampleGeneratorModal/topicExampleGeneratedList/topicExampleGeneratedListView",
], function (Marionette, $, Properties, TopicExampleGeneratedListView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicExampleGeneratedList";
    },
    // pass an optional oldest authored example from which to generate examples.
    // This example can be edited to use a custom utterance for generation.
    show: function (exampleGenerationModel, selectedLocale) {
      this.exampleGenerationModel = exampleGenerationModel;
      this.selectedLocale = selectedLocale;
      this.exampleGenerationModel.selectionInfo = $.t("topic.examples.generator.selectionInfo", {
        generatedExamplesMaxAllowedSelection: Properties.generatedExamplesMaxAllowedSelection,
      });
      this.view = new TopicExampleGeneratedListView.topicExampleGeneratedListView({
        model: this.exampleGenerationModel,
      });
      this.view.on("restrict:selected:examples", (e) => {
        const maxAllowedSelections = Properties.generatedExamplesMaxAllowedSelection;
        if (
          this.view.$el.find("input[name=generated_example]:checked").length > +maxAllowedSelections
        ) {
          $(e.target).prop("checked", false);
        }
      });

      this.showRegion(this.view);
    },
    getSelectedExampleTexts: function () {
      const exampleTexts = [];
      this.view.$el.find("input[name=generated_example]:checked").each(function () {
        exampleTexts.push($(this).val());
      });
      return exampleTexts;
    },
  });
});
